import React, { useState, useCallback } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Collapse } from 'react-bootstrap';
import messages from '../../../locale/jsonMessages';
import { ShowLessSvgIcon, ShowMoreSvgIcon } from '../Assets/SvgIconComponent/CommonSvgIcon';
import s from './ShowDescription.css';

function ShowDescription({ description, className, count, containerClass }) {
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(e => {
    e.preventDefault();
    setOpen(prev => !prev);
  }, []);

  const firstArray = description?.slice(0, count) || '';
  const restArray = description?.slice(count) || '';
  const hasOverflow = restArray.length > 0;

  return (
    <div
      className={hasOverflow ? containerClass : undefined}
    >
      <div className={className}>
        {!open && count >= 60 && (
          <span>
            {firstArray}
            {hasOverflow && '…'}
          </span>
        )}
        {hasOverflow && (
          <span>
            <Collapse in={open}>
              <div>
                {open && firstArray}
                {restArray}
              </div>
            </Collapse>
          </span>
        )}
      </div>
      {hasOverflow && <div className="d-flex">
        <button
          type="button"
          onClick={handleClick}
          className={s.showHideBtn}
        >
          {open ? <>
            <FormattedMessage {...messages.showLess} /><ShowLessSvgIcon />
          </> : <>
            <FormattedMessage {...messages.showMore} /><ShowMoreSvgIcon />
          </>}
        </button>
      </div>}
    </div>
  );
}


export default withStyles(s)(injectIntl(ShowDescription));
